import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

export const getQuestionGroupData = (questionGroup: QuestionGroup) => {
  const respondent = questionGroup.respondent
  const respondentJobTitle = respondent?.jobTitle
  const targetUser = questionGroup.target
  const targetUserjobTitle = targetUser && targetUser.jobTitle

  return {
    respondent,
    respondentJobTitle,
    targetUser,
    targetUserjobTitle,
  }
}
